import React from 'react';
import { NavLink } from 'react-router-dom';
import cn from 'classnames';
import styles from './HeaderIconButton.module.css';
import { ButtonType } from './types/HeaderIconButton';
import Icon, { IconProps } from '../../Icon';

type HeaderIconButtonProps = {
  type?: ButtonType;
  theme?: 'light' | 'dark';
  iconName: IconProps['name'];
  to?: string;
  isHeaderHovered: boolean;
  phoneText?: string;
  onClick?: () => void;
};

const HeaderIconButton: React.FC<HeaderIconButtonProps> = ({
  type = ButtonType.Light,
  theme = 'light',
  iconName,
  to,
  isHeaderHovered,
  phoneText,
  onClick,
}) => {
  const isButton = !to;

  const classNames = cn(styles.button, {
    [styles.light]: theme === 'light',
    [styles.dark]: theme === 'dark',
    [styles.button_phone]: iconName === 'icon1',
    [styles.button_favorite]: iconName === 'favorite_header',
    [styles.button_other]: iconName === 'compare_header',
    [styles.header_hovered]: isHeaderHovered,
  });

  const iconClassNames = cn(styles.icon, {
    [styles.icon_phone_light]: theme === 'light' && iconName === 'icon1',
    [styles.icon_phone_dark]: theme === 'dark' && iconName === 'icon1',
    [styles.icon_favorite]: iconName === 'favorite_header',
    [styles.icon_3]: iconName === 'compare_header',
  });

  return isButton ? (
    <button className={classNames} onClick={onClick}>
      {phoneText ? (
        <span className={styles.phoneText}>{phoneText}</span>
      ) : (
        <Icon name={iconName} className={iconClassNames} />
      )}
    </button>
  ) : (
    <NavLink
      to={to}
      onClick={onClick}
      className={({ isActive }) => cn(classNames, { [styles.active]: isActive })}
    >
      {phoneText ? (
        <span className={styles.phoneText}>{phoneText}</span>
      ) : (
        <Icon name={iconName} className={iconClassNames} />
      )}
    </NavLink>
  );
};

export default HeaderIconButton;
